export default __webpack_public_path__ + "static/CircularXXWeb-Medium-b6bc9bb18a677c747476e2d074250fdc.woff";